import { alpha } from '@mui/material/styles';
import * as colors from '../../styles/colors';
import * as media from '../../styles/media-queries';
import { isDark } from '../../utilities';

export const textFieldStyles = (theme) => ({
  'textField': {
    minHeight: 77,
    ...media.tillLargeScreen({
      minWidth: 0
    })
  },
  'textFieldContainer': {
    width: 'unset'
  },
  'textFieldContainer.fullWidth': {
    width: 'unset'
  },
  'selectField': {
    minHeight: 77,
    ...media.tillLargeScreen({
      minWidth: 0
    })
  },
  'inputLabel': {
    textTransform: 'uppercase',
    fontSize: 19,
    color: isDark(theme) ? null : alpha(colors.black, 0.64),
    fontWeight: 'bold',
    ...media.tillLargeScreen({
      fontSize: 14
    })
  },
  'switchLabel': {
    fontSize: 16,
    color: isDark(theme) ? null : alpha(colors.black, 0.64),
    fontWeight: 'bold',
    ...media.tillLargeScreen({
      fontSize: 15
    })
  }
});
